import React, { ComponentProps, useCallback, useState } from 'react';
import { useApplePayButton, ApplePayButton } from '../ApplePay';

type Props = Omit<ComponentProps<typeof ApplePayButton>, 'onClick'>;

export const CheckoutApplePayButton: React.FC<Props> = props => {
  const { getApplePayCheckoutSession } = useApplePayButton();
  const [session, setSession] = useState<ApplePaySession | null>(null);

  const onClick = useCallback(() => {
    const { version, request } = getApplePayCheckoutSession();

    if (request) {
      setSession(new ApplePaySession(version, request));
    }
  }, [getApplePayCheckoutSession]);

  return <ApplePayButton {...props} session={session} onClick={onClick} />;
};
